import { render, staticRenderFns } from "./LocaleSwitcher.vue?vue&type=template&id=366e9270&scoped=true&"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js&"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSwitcher.vue?vue&type=style&index=0&id=366e9270&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366e9270",
  null
  
)

export default component.exports